import axios from "../api/axios";
import i18next from 'i18next';
import config from '../config/configJS';
import { DEFAULT_LANG, isoLang } from '../services/language';

const CHAT_INTENT_ENDPOINTS = {
  PromptData:       '/api/chat/prompt-data',
  PromptGpt:        '/api/chat/prompt-gpt',
  PromptEmbeddings: '/api/chat/prompt-embeddings',
};

// Záložky so streamovanou odpoveďou (SSE)
export const CHAT_INTENT_STREAM_ENDPOINTS = {
  PromptGpt:        '/api/chat/prompt-gpt-stream',
  PromptEmbeddings: '/api/chat/prompt-embeddings-stream',
};

function SendData(intent, data) {
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + "/api/millai/prompt", 
        JSON.stringify({ Intent: intent, data: data }), {       
        headers: {
          'Accept': 'application/json',
           'Content-Type': 'application/json'
        },
        withCredentials: true,
      })
      .then((response) => {  
        let obj = JSON.parse(response.data);
        resolve(obj);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
  return promise;
}

function SendChatSessionData(path, sessionDto) {
  return new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + path,
        JSON.stringify(sessionDto), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function getFavouriteQuestions(intent, lang) {
  return new Promise((resolve, reject) => {
    SendData(
      'GetUserQuestions',
      {
        Intent: intent,
        Language: lang,
      }
    )
      .then((data) => {
        resolve(data.Data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err); 
      });
  });
}

export function saveFavouriteQuestion(intent, question, lang, docsEnvId) {
  if (intent == 'PromptEmbeddings') {
    return new Promise((resolve, reject) => {
      SendData('SetUserQuestions', { 
        Intent: intent, 
        Question: question, 
        Language: lang,
        DocsEnvId: docsEnvId 
      })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });   
    });
  } else {
    return new Promise((resolve, reject) => {
      SendData('SetUserQuestions', { 
        Intent: intent, 
        Question: question, 
        Language: lang
      })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });   
    });
  } 
}

export function publishFavouriteQuestion(id, isPublic) {
  return SendData('PublishUserQuestion', { Id: id, IsPublic: isPublic });
}

export function deleteFavouriteQuestion(id) {
  return new Promise((resolve, reject) => {
    SendData('RemoveUserQuestions', { Id: id })
      .then((data) => {
        resolve(true);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

export function saveQuestionRating(msg, rating){
  return new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + "/api/chathistory/rating",
        JSON.stringify({
          MessageID: msg,
          Rating: rating,
        }), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function saveQuestionReview(msg, review){
  return new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + "/api/chathistory/review",
        JSON.stringify({
          MessageID: msg,
          Review: review,
        }), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

// Zostaví ChatSessionDto pre odoslanie (zdieľané pre normálny aj streamovaný request)
function buildChatSessionDto(selectedIntent, messageHistory, formData, id, docsEnvId, tabItemId, currentSessionId, messageId, sessionTitle) {
  const newMessage = messageHistory.map((item) => {
    if (item.intent === selectedIntent) {
      return {
        ...item,
        chat: [...item.chat, { id: id, Type: 0, Role: 'user', Message: formData, MessageID: messageId }]
      };
    }
    return item;
  });

  const { chat } = newMessage.find((item) => item.intent === selectedIntent);
  const Messages = chat.filter(item => item.Type != 4 && item.Type !== 'loading');

  let messagesToSend = Messages;
  const resetIndex = messagesToSend.findIndex(m => m.Type === 5);
  if (resetIndex !== -1) {
    messagesToSend = messagesToSend.slice(resetIndex + 1);
  }
  messagesToSend = messagesToSend.slice(-12);

  const chatMessagesDto = messagesToSend.map((msg) => ({
    id: typeof msg.id === 'number' ? msg.id : (typeof msg.Id === 'number' ? msg.Id : 0),
    messageId: msg.MessageID || msg.messageId,
    sessionId: currentSessionId,
    chatRole: msg.Role,
    contentType: msg.Type,
    content: msg.Type === 1 ? '' : (typeof msg.Message === 'string' ? msg.Message : ''),
    metadata: {
       table: msg.Table || msg.metadata?.table,
       generatedSQL: msg.GeneratedSQL || msg.metadata?.generatedSQL,
       userDocsMessages: msg.Metadata || msg.metadata?.userDocsMessages,
       docsEnvId: docsEnvId,
       tabItemId: tabItemId,
       systemMessage: msg.SystemMessage || msg.metadata?.systemMessage
    }
  }));

  return {
    id: currentSessionId,
    userId: '0',
    intent: selectedIntent,
    title: sessionTitle,
    messages: chatMessagesDto
  };
}

// Z ChatSessionDto (z BE) spraví normalizovaný objekt správy, ktorý očakáva UI
function normalizeSessionResponse(returnedSession, status) {
  const msgs = returnedSession ? (returnedSession.messages || returnedSession.Messages) : null;
  if (!returnedSession || !msgs || msgs.length === 0) {
    return null;
  }
  const lastMsg = msgs[msgs.length - 1];
  const meta = lastMsg.metadata || lastMsg.Metadata || {};
  const msgType = lastMsg.contentType ?? lastMsg.ContentType ?? lastMsg.Type;

  const rawTable = meta.table || meta.Table;
  const normalizedTable = rawTable ? {
    Rows: rawTable.Rows || rawTable.rows,
    Columns: (rawTable.Columns || rawTable.columns || []).map(col => ({
      ...col,
      Name: col.Name || col.name,
      DatabaseType: col.DatabaseType || col.databaseType,
    })),
  } : null;

  const messageContent = msgType === 1
    ? normalizedTable
    : (lastMsg.content ?? lastMsg.Content ?? lastMsg.Message ?? '');

  return {
    SessionId: returnedSession.id || returnedSession.Id,
    Role: lastMsg.chatRole || lastMsg.ChatRole || lastMsg.Role,
    Type: msgType,
    Rating: lastMsg.rating ?? lastMsg.Rating ?? null,
    Message: messageContent,
    Table: normalizedTable,
    SystemMessage: meta.systemMessage || meta.SystemMessage,
    GeneratedSQL: meta.generatedSQL || meta.GeneratedSQL,
    MessageID: lastMsg.messageId || lastMsg.MessageId || lastMsg.id || lastMsg.Id,
    UserMessageID: msgs.length > 1 ? (msgs[msgs.length - 2].id || msgs[msgs.length - 2].Id) : null,
    WelcomeMessageID: msgs.length > 2 ? (msgs[0].id || msgs[0].Id) : null,
    Metadata: meta.userDocsMessages || meta.UserDocsMessages,
    ExtractionTaskId: meta.extractionTaskId || meta.ExtractionTaskId,
    EnvironmentType: returnedSession.contextType || returnedSession.ContextType,
    Status: status
  };
}

export function sendMessageToBE(selectedIntent, messageHistory, formData, id, docsEnvId, tabItemId, currentSessionId = 0, messageId = null, sessionTitle = null) {
  return new Promise((resolve, reject) => {
    const chatSessionDto = buildChatSessionDto(selectedIntent, messageHistory, formData, id, docsEnvId, tabItemId, currentSessionId, messageId, sessionTitle);

    const chatEndpoint = CHAT_INTENT_ENDPOINTS[selectedIntent];
    const sendPromise = chatEndpoint
      ? SendChatSessionData(chatEndpoint, chatSessionDto)
      : SendData(selectedIntent, chatSessionDto);

    sendPromise.then((data) => {
      // Nové endpointy vracajú ChatSessionDto priamo, staré cez data.Data wrapper
      const returnedSession = chatEndpoint ? data : data.Data;
      const normalized = normalizeSessionResponse(returnedSession, data.Status);
      if (!normalized) {
        reject('No messages returned'); return;
      }
      resolve(normalized);
    }).catch(reject);
  });
}

// Streamovaná verzia (SSE) pre PromptEmbeddings a PromptGpt — krokový progres + finálna odpoveď.
// callbacks: { onSession(sessionId), onStep(stepEvent), onToken(deltaText), onDone(normalizedMessage), onError(err) }
export function sendMessageToBEStream(selectedIntent, messageHistory, formData, id, docsEnvId, tabItemId, currentSessionId = 0, messageId = null, sessionTitle = null, { onSession, onStep, onToken, onDone, onError, signal } = {}) {
  const chatSessionDto = buildChatSessionDto(selectedIntent, messageHistory, formData, id, docsEnvId, tabItemId, currentSessionId, messageId, sessionTitle);

  const redirectToLogin = () => {
    window.location = '/Login';
  };

  const isUnauthorized = (value) => {
    const text = typeof value === 'string' ? value : JSON.stringify(value || '');
    const normalized = text.toLowerCase();
    return normalized.includes('401') || normalized.includes('unauthorized');
  };

  const url = config.endPoint + CHAT_INTENT_STREAM_ENDPOINTS[selectedIntent];
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'text/event-stream',
    'Accept-Language': isoLang(i18next.language || DEFAULT_LANG),   // hlásenia servera v jazyku aplikácie
  };
  // rovnaká autentifikácia ako axios interceptor (AD token z localStorage; JWT cez cookie)
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['ad'] = 'true';
  }

  return fetch(url, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(chatSessionDto),
    signal
  })
    .then(async (response) => {
      if (response.status === 401) {
        redirectToLogin();
        return;
      }

      if (!response.ok || !response.body) {
        throw new Error('Stream request failed: ' + response.status);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const handleEvent = (evt) => {
        if (!evt || !evt.type) return;
        if (evt.type === 'session') {
          // id konverzácie hneď na začiatku (aj keď sa odpoveď neskôr zastaví)
          if (onSession && evt.session_id) onSession(evt.session_id);
        } else if (evt.type === 'step') {
          if (onStep) onStep(evt);
        } else if (evt.type === 'token') {
          if (onToken) onToken(evt.delta || '');
        } else if (evt.type === 'done') {
          const session = evt.session || evt.Session;
          const normalized = normalizeSessionResponse(session, null);
          if (onDone) onDone(normalized);
        } else if (evt.type === 'error') {
          if (isUnauthorized(evt.detail)) {
            redirectToLogin();
            return;
          }
          // posli aj kód chyby (napr. 'no_documents'), nech FE ukáže konkrétnu hlášku
          if (onError) onError({ detail: evt.detail || 'error', code: evt.code });
        }
      };

      // čítanie SSE: udalosti sú oddelené prázdnym riadkom, dáta na riadku "data: {...}"
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        let sepIndex;
        while ((sepIndex = buffer.indexOf('\n\n')) !== -1) {
          const rawEvent = buffer.slice(0, sepIndex);
          buffer = buffer.slice(sepIndex + 2);

          const dataLine = rawEvent.split('\n').find(l => l.startsWith('data:'));
          if (!dataLine) continue;
          const jsonStr = dataLine.slice(5).trim();
          if (!jsonStr) continue;

          try {
            handleEvent(JSON.parse(jsonStr));
          } catch (e) {
            console.warn('SSE parse error', e, jsonStr);
          }
        }
      }
    })
    .catch((err) => {
      // zámerne prerušený stream (STOP alebo nový dotaz) -> ticho ukončiť, žiadna chyba
      if (err?.name === 'AbortError') {
        return;
      }
      console.error('sendMessageToBEStream error', err);
      if (isUnauthorized(err?.message || err)) {
        redirectToLogin();
        return;
      }
      if (onError) onError(err);
    });
}
